import {
  limits,
  linkedAccounts,
  manageAccounts,
  manageUsers,
  personalInfo,
} from '@services/sections/lib/settings'

import type { GroupProps } from '../../MainNav/MainNav.Groups/Group/Group'

/**
 * Settings Groups.
 */
export const groups: GroupProps[] = [
  {
    header: 'layout:nav.settings.profile',
    items: [personalInfo],
  },
  {
    header: 'layout:nav.settings.organization',
    items: [manageUsers, manageAccounts],
  },
  {
    header: 'layout:nav.settings.transactions',
    items: [linkedAccounts, limits],
  },
]
